import { render } from "./SendIssue.vue?vue&type=template&id=fc7c60ea&scoped=true"
import script from "./SendIssue.vue?vue&type=script&lang=js"
export * from "./SendIssue.vue?vue&type=script&lang=js"

import "./SendIssue.vue?vue&type=style&index=0&id=fc7c60ea&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc7c60ea"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QToolbar,QToolbarTitle,QBtn,QList,QItem,QItemSection,QCheckbox,QItemLabel,QInput,QPageSticky});qInstall(script, 'directives', {Ripple});
